<div class="item-buttons">
    @if (showExploreButton) {
        <tec-button size="sm" (click)="onExploreClick()">
            {{ 'DOCUMENTS.EXPLORE' | translate }}
        </tec-button>
    }

    @if (showTakePhotoButton) {
        <tec-button type="secondary" size="sm" icon="icon-camera" iconPosition="left" (click)="onTakePhotoClick()">
            {{ 'DOCUMENTS.TAKE_PHOTO' | translate }}
        </tec-button>
    }
</div>
